module.exports = __webpack_public_path__ + "static/media/img_3.ace8c442.jpg";